(function($) {
    $(function() {
        var $calendarBox = $('.calendar-block');
        var $calendarBtn = $('.cal-button');
        $calendarBtn.on('click', function() {
            var $target = $(this).closest('.calendar-block');
            $calendarBox.show();
            $target.hide();
        });
    });
    /**
     * Validate
     */
    $(function() {
        var count = 0;
        var $requiredRow = $('.requiredRow');
        var $target      = $requiredRow.find('input,select');
        var $display     = $('#remaining');

        var $ngIcon = $('<span class="box box-req">必須</span>');
        var $okIcon = $('<span class="box box-ok">OK</span>');

        function checkCount() {
            count = 0;

            $requiredRow.each(function() {
                var flag = false;

                $(this).find('input[type="checkbox"],input[type="radio"]').each(function() {
                    if($(this).prop('checked')) {
                        flag = true;
                        return false;
                    }
                });

                $(this).find('select').each(function() {
                    if($(this).val()) {
                        flag = true;
                        return false;
                    }
                });

                var $replace = null;
                if(! flag) {
                    count += 1;
                    $replace = $ngIcon.clone();
                    $(this).addClass('ng-row');
                    $(this).removeClass('ok-row');
                } else {
                    $replace = $okIcon.clone();
                    $(this).removeClass('ng-row');
                    $(this).addClass('ok-row');
                }

                var $box  = $(this).find('.box.box-req, .box.box-ok');
                $box.each(function() {
                    $(this).replaceWith($replace);
                });
            });

            $display.text(count);
        }
        $target.on('change', checkCount);
        checkCount();

        $('form').on('submit', function() {
            if(count > 0) {
                return false;
            }
        });


        // ----------------------------- add by spaceclick
        var statusLabel = [ '','空きあり','残りわずか','満席' ];

        // カレンダー日付選択時
        $(".calendar-block table td.selectable").on('click', function(e) {
            var timesList = $(".radio-wrap .radio-block");
            var selectTitle = $(this).attr("data-title");
            var selectDate = $(this).attr("data-date");

            // クリア
            timesList.html("");
            $("#frame_id").val("");
            $("#visit_datetime").val("");
            $("#visit_datetime_label").val("");
            $(".calendar-block table td.selectable").removeClass("selected");
            $(".radio-block > label").removeClass("active");

            // 日付を選択状態にする
            $(this).addClass("selected");

            // 日付表示
            $(".radio-wrap p").html( selectTitle );

            // 時間表示
            $(this).children(".times").each( function( index, ele ){
                var id = $(this).attr("data-id");
                var status = $(this).attr("data-status");
                var time = $(this).attr("data-visittime");
                var disabled = "";
                if( status == 3 ) disabled =  "disabled";

                if( time.length > 5 ) time = time.slice( 0, 5 );
                timesList.append( '<label class="' + disabled + '"><input type="radio" name="time" value="' + time + '" data-id="' + id + '" ' + disabled + ' > ' + time + '　' + statusLabel[status] + '</label>' );
            });

            // 時間選択時
            timesList.find('input').each(function() {
                $(this).on('change', function(e) {
                    // ID,日付設定
                    $("#frame_id").val( $(this).attr("data-id") );
                    $("#visit_datetime").val( selectDate + ' ' + $(this).val());
                    $("#visit_datetime_label").val( selectTitle + ' ' + $(this).val());

                    // 選択状態に
                    $(".radio-block > label").removeClass("active");
                    $(this).parents("label").addClass("active");

                    checkCount();
                });
            });

            // 時間枠表示
            timesList.show();

            checkCount();
        });
        // ----------------------------- /add by spaceclick



    });
})(jQuery);
